import React from 'react';
import ReactDOM from 'react-dom';
import { COUCHE_TOAST } from './Toast';
import { getToastRoot } from '../ToastPortal';
import { AlertCircle, CheckCircle, Info, X } from 'lucide-react';

const toneClasses = {
  success: {
    border: 'border-emerald-200',
    iconWrap: 'bg-emerald-50 text-emerald-700',
    icon: CheckCircle,
    title: 'Opération terminée'
  },
  warning: {
    border: 'border-amber-200',
    iconWrap: 'bg-amber-50 text-amber-700',
    icon: AlertCircle,
    title: 'Vérification requise'
  },
  error: {
    border: 'border-red-200',
    iconWrap: 'bg-red-50 text-red-700',
    icon: AlertCircle,
    title: 'Opération refusée'
  },
  info: {
    border: 'border-blue-200',
    iconWrap: 'bg-blue-50 text-blue-700',
    icon: Info,
    title: 'Information'
  }
};

export const getLongToastTitle = (type = 'error', title = '') => (
  title || toneClasses[type]?.title || toneClasses.info.title
);

export const shouldUseLongToast = (message, type = 'success', options = {}) => {
  const text = String(message || '');
  return type !== 'loading' && (options.persistent || options.long || text.length > 130);
};

export const LongToast = ({
  show = true,
  title = '',
  message = '',
  type = 'error',
  onClose
}) => {
  if (!show || !message) return null;

  const normalizedType = toneClasses[type] ? type : 'info';
  const tone = toneClasses[normalizedType];
  const Icon = tone.icon;

  // Comme le toast court : rendu dans le conteneur dédié, pour ne dépendre
  // d'aucun contexte d'empilement.
  return ReactDOM.createPortal((
    <div className={`fixed inset-x-0 top-8 ${COUCHE_TOAST} flex justify-center px-4 pointer-events-none`}>
      <div className={`pointer-events-auto w-full max-w-2xl rounded-xl border bg-white shadow-2xl ${tone.border}`}>
        <div className="flex items-start gap-3 p-4">
          <div className={`mt-0.5 rounded-lg p-2 ${tone.iconWrap}`}>
            <Icon size={20} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="font-semibold text-gray-900">{getLongToastTitle(normalizedType, title)}</p>
            <p className="mt-1 text-sm leading-relaxed text-gray-700 whitespace-pre-line">{message}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Fermer"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  ), getToastRoot());
};

export default LongToast;
